import module from 'finanzas/module.js'
import template from './template.html'

module.config(($dialogProvider) => {
  $dialogProvider.dialog('finances.divisas.agregar', {
    template,
    controllerAs: 'ctrl',
    controller: FinancesDivisasAgregarController,
  })
})

function FinancesDivisasAgregarController (dialog, FinanzasDivisas, $dialogParams, $scope) {
  var ctrl = this
  ctrl.saving = false
  ctrl.data = $dialogParams['data']

  ctrl.cancel = function () {
    dialog.reject()
  }

  ctrl.add = function () {
    ctrl.saving = true
    FinanzasDivisas.set(ctrl.data).then(function () {
      dialog.resolve()
    }).finally(function () {
      ctrl.saving = false
    })
  }

  $scope.$watch('ctrl.data.Compra', function (valor) {
    ctrl.data.Compra_Operativa = valor
    ctrl.data.Venta = valor
    ctrl.data.Venta_Operativa = valor
  })
}

module.controller('FinancesDivisasAgregarController', FinancesDivisasAgregarController)



// WEBPACK FOOTER //
// ./src/finanzas/_/divisas/agregar/finances-divisas-agregar.js